import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';

export default class Modalsuccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
          modal: false,

          inside:"",
          faculty:"",
          Expert:[],
          idExpert:"",
          id_send:"",
          send_comment1:"",
          success:"",
          filecomment1:null,
        }

this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
//this.getExpert = this.getExpert.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
  this.props.selectatf();
}


 componentDidMount() {
      const { id_send } = this.props.id_send
      console.log(id_send);
      this.setState({ id_send:this.props.id_send})
    //   setTimeout(() => {
    //     //ภายใน
    //      Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
    //     .then(res => {
    //       console.log(res);
    //     //  this.setState({ bankname: res.data, loading: false })
    //       this.setState({ Expert: res.data})
    //     }) 

    //   }, 0);

  }

//   getExpert() {
//     setTimeout(() => {
//       //ภายใน
//        Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
//       .then(res => {
//         console.log(res);
//       //  this.setState({ bankname: res.data, loading: false })
//         this.setState({ Expert: res.data})
//       }) 

//     }, 0);

// }


  handleChange(event) {    this.setState({success: event.target.value});  }
  handleChange2(event) {    this.setState({send_comment1: event.target.value});  }


  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("idsend", this.state.id_send);
     // datafrm.append("send_comment1", this.state.send_comment1);
      datafrm.append("success", this.state.success);
      

//อัพเดทสถานะ
  Axios
  // .post("https://admission.kpru.ac.th/refund/api/getdata/getuseradmin", { Username: this.form.name, Password: this.form.pass })
    .post("https://edu.kpru.ac.th/conference/PHPAPI/updatestapat6.php",datafrm)
    .then(res => {
      console.log("response: ", res)
 
      if (res.data.length !== 0) {
       // this.showitem = true;
        console.log(res)
        console.log(res.data.length)
     }else{
      // window.location.href = '/'
     }
   })
 //  window.location.href = '/adminfaculty'
  this.toggle()
}, 2000);

  //this.props.updateat();
  //this.getExpert()
 
  }

  

    render() {
        
        return (
            <MDBContainer>
            <MDBBtn onClick={this.toggle}>สถานะ</MDBBtn>

            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>{this.props.namearticla}</MDBModalHeader>
              <MDBModalBody>
              <div>

              <p>สถานะบทความ</p>
        <select className="browser-default custom-select" onChange={this.handleChange}>
                   <option>------กรุณาเลือกสถานะ------</option>
                   <option value="6">ผ่านการพิจารณา</option>
                   <option value="7">ไม่ผ่านการพิจารณา</option>
                  
        </select>


              </div>
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}
